export default function handleActions(defaultState, map) {
  return (state = defaultState, action = {}) => {
    const fn = map[action.type];
    return fn ? fn(state, action) : state;
  };
}
